import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Listen from './pages/Listen';
import Members from './pages/Members';
import Schedule from './pages/Schedule';
import Photos from './pages/Photos';
import Contact from './pages/Contact';
import './App.css';
import usePreloadImages from './hooks/usePreloadImages';


function AnimatedPage({ children }) {
  return (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y:-20 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
        {children}
    </motion.div>
);
}

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  usePreloadImages([
    '/images/group/1.jpeg',
    '/images/group/5.png',
    '/images/group/8.jpeg',
    '/images/group/9.jpeg',
    '/images/group/10.jpg',
    '/images/group/13.jpg',
    '/images/group/17.png',
    '/images/group/18.png',
    '/images/group/19.png',
    '/images/group/DSC05328.JPG',
    '/images/group/DSC05339.JPG',
    '/images/group/DSC05352.JPG',
    '/images/group/DSC05370.JPG',
    '/images/group/DSC05391.JPG',
    '/images/group/DSC05403.JPG',
    '/images/group/DSC05479.JPG',
    '/images/group/DSC05524.JPG',
    '/images/group/DSC05534.JPG',
    '/images/group/EGC09419A.JPG',
    '/images/group/EGC09430A.JPG',
    '/images/group/EGC09477A.JPG',
    '/images/group/EGC09548A.JPG',
    '/images/group/KQ_012.jpeg',
    '/images/group/_DSC6640b.jpg',
    '/images/group/_DSC6708.JPG',
    '/images/group/_DSC6809.JPG',
    '/images/group/_DSC6821.JPG',
    '/images/group/_DSC6837.JPG',
    '/images/group/_DSC6862.JPG',
    '/images/group/_DSC6902.JPG',
    '/images/listen/DSC05479.webp',
    '/images/listen/EGC09419A.webp',
    '/images/listen/EGC09430A.webp',
    '/images/listen/insta1.webp',
    '/images/members/Dan.webp',
    '/images/members/Ellie.webp',
    '/images/members/Evan.webp',
    '/images/members/Evan2.webp',
    '/images/members/Grace.webp',
    '/images/members/Johnny2.webp',
    '/images/members/Mas.webp',
    '/images/members/Matt.webp',
    '/images/members/Nick.webp',
    '/images/members/Scott.webp',
    '/images/members/Seth.webp',
  ])
  return (
      <div className="App">
          <Navbar />
          <main className="main-content">
              <AnimatePresence mode="wait">
                  <Routes location={location} key={location.pathname}>
                      <Route path="/" element={<AnimatedPage><Home /></AnimatedPage>} />
                      <Route path="/about" element={<AnimatedPage><About /></AnimatedPage>} />
                      <Route path="/listen" element={<AnimatedPage><Listen /></AnimatedPage>} />
                      <Route path="/members" element={<AnimatedPage><Members /></AnimatedPage>} />
                      <Route path="/schedule" element={<AnimatedPage><Schedule /></AnimatedPage>} />
                      <Route path="/photos" element={<AnimatedPage><Photos /></AnimatedPage>} />
                      <Route path="/contact" element={<AnimatedPage><Contact /></AnimatedPage>} />
                  </Routes>
              </AnimatePresence>
          </main>
          <Footer />
      </div>
  );
}

export default App;